import React from 'react'
import cs from 'classnames'

import './style.sass'

export type BoldTextProps = {
	children: React.ReactNode
	className?: string
}
export default function BoldText({ children, className = '' }: BoldTextProps): React.ReactNode {
	const cx: string = cs('BoldText', className)
	return <b className={cx}>{children}</b>
}
